<h1 mat-dialog-title>Add New Device</h1>
<div mat-dialog-content>
  <form #form="ngForm">
    <label class="field">
      <span class="mat-body-strong">Label</span>
      <mat-form-field appearance="outline">
        <input data-id="new-device-label" matInput name="label" required test-id="label" [(ngModel)]="label" />
        <mat-error>Label is required</mat-error>
      </mat-form-field>
    </label>
    <label class="field">
      <span class="mat-body-strong">Type</span>
      <mat-form-field appearance="outline">
        <mat-select data-id="new-device-type" name="type" test-id="type" [(ngModel)]="type">
          <mat-option value="reaper">Reaper</mat-option>
          <mat-option value="importer">Importer</mat-option>
        </mat-select>
      </mat-form-field>
    </label>
    @if (providerOptions) {
      <label class="field">
        <span class="mat-body-strong">Storage Provider</span>
        <mat-form-field
          appearance="outline"
          fwTooltip="Choose a storage provider that will be used when files are created with this device. Site provider is the default. Project provider is based on the parent project of the location where files are uploaded."
          fwTooltipPosition="right"
        >
          <mat-select test-id="storage-provider" [value]="provider" (selectionChange)="provider = $event.value">
            <mat-option value="site">Use Site Provider</mat-option>
            <mat-option value="project">Use Project Provider</mat-option>
            @for (group of providerOptions; track group) {
              <mat-optgroup [label]="group.label">
                @for (option of group.providers; track option) {
                  <mat-option
                    fwTooltipClass="tooltip-preformatted"
                    fwTooltipPosition="right"
                    [fwTooltip]="option.tooltip"
                    [value]="option.value"
                    >{{ option.label }}</mat-option
                  >
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </label>
    }
  </form>
</div>
<div align="end" mat-dialog-actions>
  <button data-id="device-modal-close" mat-stroked-button test-id="close" (click)="onClose()">Close</button>
  <button cdkFocusInitial color="primary" data-id="device-modal-add" mat-flat-button test-id="add" (click)="onAdd()">
    Add
  </button>
</div>
